export enum AppointmentStatus {
  Appointed = 0,
  Postponed = 1,
  InProgress = 2,
  Processed = 3,
  Cancelled = 4,
  // New, //Новая
  // Appointed, //Назначен
  // Success, //Выполнена
  // Cancel, //Отменено
}
